module.exports = __webpack_public_path__ + "static/media/project19.8cced683.jpg";